import { Box, FormLabel, Button, ButtonGroup, Stack, Divider, useMediaQuery } from '@mui/material';

import Alert from '@mui/material/Alert';
import React, {useContext, useState} from 'react';

import { AddCircleSharp, DeleteForeverSharp, SpeedSharp } from '@mui/icons-material';
import {bssMakeStyles,  breakpointComparator, width2Breakpoint } from '../../lib/theming'
import BSSStyleContext from '../../contexts/BSSStyleContext';
import __t from '../../lib/traduzioni';
import BSSRadioButtons from '../form/BSSRadioButtons';
import BSSNumber from '../form/BSSNumber';
import { Controller, useFieldArray, useWatch } from 'react-hook-form';
import useBSSLogger from '../../hooks/useBSSLogger';
import BSSPreventivoContext from '../../contexts/BSSPreventivoContext';
import { useTheme } from '@emotion/react';
import BSSSelect from '../form/BSSSelect';
import DrawerMisurePredefinite from './pacchi/DrawerMisurePredefinite';
import DialogNuovaMisura from './pacchi/DialogNuovaMisura';
import { Grid } from '@mui/material';


const {logger} = useBSSLogger();

/**
 * 
 * @param {Collo} collo 
 * @returns {String}
 */
const subTitleTipiColli = ({larghezza, lunghezza, altezza, peso}) => {
    const la = lunghezza && altezza && larghezza ? `(${lunghezza}x${altezza}x${larghezza})CM\u00B3` : null; 
    const pe = peso ? `${peso}KG` : null;
    let label = "";
    const esitope = pe !== null;
    if(la !== null){
        label += la;
        if(esitope){
            label += " ";
        } 
    }

    if(esitope){
        label += pe;
    }

    return label;
}

const CampiNum = [
    {label: __t("lungh"), name: "lunghezza"},
    {label: __t("alt"), name: "altezza"},
    {label: __t("largh"), name: "larghezza"},
    {label: __t("peso"), name: "peso"},
    {label: __t("qta"), name: "qta"},
]

const colloDefault = {
    lunghezza: null,
    altezza: null,
    larghezza: null,
    peso: null,
    qta: 1,
};

const mappaValidazione =  {
    lunghezza: "maxBaseMaggiore",
    larghezza: "maxBaseMinore",
    altezza: "maxAltezza",
    peso: "maxPesoPacco",
    qta: "maxNumeroColli"    
}

const mappaValidazioneTotali = {
    maxNumeroColliTotali: "sommaQta",
    maxPesoTotale: "sommaPesi",
    //maxVolumeTotale: "sommaVolumi",
}

const volumeCollo = ({larghezza = 0, lunghezza = 0, altezza = 0}) => {
    return Number(larghezza) * Number(lunghezza) * Number(altezza);
}

const validateTotali = (chiave, limitiGenerali, colliaggiornati) => {
    const valore = totali(colliaggiornati)?.[mappaValidazioneTotali[chiave]] ?? null;
    const limite = limitiGenerali?.[chiave] ?? null;
    logger.debug("validazione per", chiave, "il totale interessato è", mappaValidazioneTotali[chiave])
    logger.debug("validazione il valore da validare è", valore)
    logger.debug("validazione il limite da non superare è", limite)
    let esito = true;
    if(valore !== null && limite !== null){
        logger.debug("validazione", valore, "non deve superare", limite)
        
        esito = esito && valore <= limite
    }
    return esito === true ? esito : __t(chiave, [limite]);        
}



const validateVolume = (valore, limitiGenerali) => {
    const limite = limitiGenerali?.maxVolumePacco ?? null;
    logger.debug("validazione volume del singolo collo", valore, "non deve superare", limite)
    let esito = true;
    if(limite !== null){
        esito = esito && valore <= limite;
    }
    return esito === true ? esito : __t("maxVolumePacco", [limite]);
}

/**
 * controlli aggiuntivi sui pacchi
 * 1. somma delle qta <= maxNumeroColliTotali
 * 2. somma dei pesi <= maxPesoPaccoTotale
 * 3. somma dei volumi <= maxVolumeTotale
 * 4. il singolo volume <= maxVolumePacco
 */

    const totali = (colliaggiornati) => {
    const totale = colliaggiornati.reduce((obj, {larghezza = 0, lunghezza = 0, altezza = 0, qta = 0, peso = 0}) => {

        larghezza = Number(larghezza);
        lunghezza = Number(lunghezza);
        altezza = Number(altezza);
        peso = Number(peso);
        qta = Number(qta);

        return {
            ...obj,
            sommaQta: Number(obj.sommaQta) + qta,
            sommaPesi: Number(obj.sommaPesi) + (peso * qta),
            sommaVolumi: Number(obj.sommaVolumi) + (larghezza * altezza * lunghezza * qta)
        }
        
    }, {sommaQta: 0, sommaPesi: 0, sommaVolumi: 0});
    logger.debug("pacchi totali calcolati sulla base di", colliaggiornati, totale)

    return totale;
}

const Pacchi = ({title, methods, daShortcode}) => {
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const classes = bssMakeStyles();
    
    const [drawerTipiColli, setDrawerTipiColli] = useState({open: false, index: -1});

    const [openDialogNuovaMisura, setOpenDialogNuovaMisura] = useState(false)     
    
    
    const {tipiSpedizione, misurePredefinite, aggiornaPreferenze} = useContext(BSSPreventivoContext);

    const tipoSelezionatoRT = useWatch({name: "tipoSelezionato"})

    const objTipoSelezionato = tipiSpedizione.find(ts => ts.id === tipoSelezionatoRT) ?? {};
    const codiceTipo = objTipoSelezionato?.codice ?? null;

    // const {colli: colliaggiornati = []} = useWatch("colli");

    //logger.debug("colli aggiornati", colliaggiornati)

    const aggiornaMisure = (index, misure) => {
        ["altezza", "larghezza", "lunghezza", "peso"].forEach(campo => {
            methods.setValue(`colli.${index}.${campo}`, misure[campo]);
        })
    }

    const selezionaMisura = (option) => {
        logger.debug("selezionato tipo collo preesistente", option, "aggiorno", drawerTipiColli.index);

        aggiornaMisure(drawerTipiColli.index, option)

        // methods.setValue(`colli.${drawerTipiColli.index}`, {...option, id: undefined})
        setDrawerTipiColli({
            open: false,
            index: -1
        })    
    }
    
    return (
        <>
            <DialogNuovaMisura {...{
                aggiornaPreferenze,
                objTipoSelezionato,
                openDialogNuovaMisura,
                setOpenDialogNuovaMisura,
                tipiSpedizione,
                drawerTipiColli,
                setDrawerTipiColli
            }} />
        

            <DrawerMisurePredefinite {...{
                codiceTipo,
                drawerTipiColli,
                misurePredefinite,
                selezionaMisura,
                setDrawerTipiColli,
                subTitleTipiColli,
                setOpenDialogNuovaMisura
            }} />

            {(isMobile || tipiSpedizione.length > 5) ? (
                <Stack>
                    <Divider />
                    <Box py={1}>                    
                        <BSSSelect
                            label={__t("cosaspedisci")}
                            name={"tipoSelezionato"}
                            methods={methods}
                            dataProvider={tipiSpedizione.map(ts => ({value: ts.id, label: `${ts?.descrizione ?? ts.id}`}))}
                        />
                    </Box>
                    <Divider />
                </Stack>
                
            ): (
                <Box display={"flex"}>
                    <Box flexGrow={1}> 
                        <FormLabel className={classes.label} sx={{lineHeight: 2 }}>
                            {title}
                        </FormLabel>
                    </Box>
                    <Box>
                        <BSSRadioButtons 
                            name={"tipoSelezionato"}  
                            methods={methods}                                        
                            dataProvider={tipiSpedizione.map(ts => ({value: ts.id, label: ts?.descrizione ?? ts.id}))}
                        />
                    </Box>
                </Box>   
            )}   
            <_Pacchi {...{tipoSelezionatoRT, methods, setDrawerTipiColli}} />        
                    
        </>
    )
}

const _Pacchi = ({tipoSelezionatoRT, methods, setDrawerTipiColli}) => {

    const {control} = methods;
    const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
        control,
        name: "colli"
    }); 

    const {tipiSpedizione, limitiGenerali} = useContext(BSSPreventivoContext);

    const {colli: colliaggiornati = []} = useWatch("colli");

    const {mainContainerWidth, theme} = useContext(BSSStyleContext);
    const cw = width2Breakpoint(mainContainerWidth, theme);
    const fullWidthBtnGroup = breakpointComparator({currBreakpoint: cw, compareToBreakpoint: 'lg', operator: 'lte', theme});


    return (
        <>
            {Object.keys(mappaValidazioneTotali).map((chiaveLimite, indiceChiaveLimite) => {

                return (
                    <Box width={1} key={indiceChiaveLimite}>
                        {/* <pre>{JSON.stringify(validateVolume(getValues(`colli.${index}`)), null, 2)}</pre> */}
                        <Controller 
                            control={control}
                            name={chiaveLimite}
                            rules={{
                                validate: value => validateTotali(chiaveLimite, limitiGenerali, colliaggiornati),
                            }}
                            value={totali(colliaggiornati)[mappaValidazioneTotali[chiaveLimite]]}
                            render={({field, fieldState}) => {
                                return (
                                    <>
                                        {(fieldState?.error ?? false) && (
                                            <Alert  severity="error">
                                                {fieldState.error.message}
                                            </Alert>                                                            
                                        )}
                                        <input readOnly hidden
                                            {...field}
                                            value={totali(colliaggiornati)[mappaValidazioneTotali[chiaveLimite]]}
                                        />
                                        
                                    </>
                                    
                                )
                            }}
                        
                        />
                
                    </Box>
                )
            })}
            

            {fields.map((item, index) => {

                logger.debug("valore item indice", index, item)

                return (
                    
                    <Box mt="0.5em" key={item.id}>

                        {/* <fieldset>
                            <legend>{tipiSpedizione.find(ts => ts.id === tipoSelezionatoRT)?.multiDescr?.testo ?? ""} #{index+1}</legend> */}

                            <Grid container direction="row">
                                

                                {colliaggiornati[index] && (
                                    <Grid item width={1} my={1} >
                                        <Controller 
                                            control={control}
                                            name={`colli.${index}.totali`}
                                            value={volumeCollo(colliaggiornati[index])}
                                            render={({field, fieldState}) => {
                                                return (
                                                    <>
                                                        {(fieldState?.error ?? false) && (
                                                            <Alert  severity="error">
                                                                {fieldState.error.message}
                                                            </Alert>                                                            
                                                        )}
                                                        <input readOnly type="hidden"
                                                            {...field}
                                                            value={volumeCollo(colliaggiornati[index])}
                                                        />
                                                        
                                                    </>
                                                    
                                                )
                                            }}
                                        
                                        />
                                        
                                    </Grid>
                                )}
                                


                                {CampiNum.map((campo, indiceCampo) => {

                                    const minVal = campo.name !== 'qta' ?  0.01 : 1;
                                    const maxVal = limitiGenerali?.[mappaValidazione[campo.name]] ?? null;
                                    
                                    let rules = {
                                        required: __t("validazione.requiredField", [campo.label]), 
                                        min: {
                                            value: minVal,
                                            message: __t("validazione.min", [minVal])
                                        }
                                    }

                                    if(maxVal !== null){
                                        rules.max = {
                                            value: maxVal,
                                            message: __t("validazione.max", [maxVal])
                                        }
                                    }
                                    

                                    return(


                                        <Grid item width={{xs: 1, sm: 1, md: 2/12, lg: 2/12}[cw]} 
                                            mb={{xs: "0.5em", sm: "0.5em", md: "0.5em"}} 
                                            key={indiceCampo}
                                            >

                                            <BSSNumber 
                                                name={`colli.${index}.${campo.name}`} 
                                                label={`${campo.label}`}    
                                                methods={methods}                                        
                                                NumberFormatProps={campo.name === 'qta' ? {decimalScale: 0} : {}}
                                                ControllerProps={{
                                                    rules,
                                                    defaultValue: item[campo.name]
                                                }}                                            
                                            />  
                                            
                                        </Grid>

                                    )
                                })}                    
                                <Grid item width={{xs: 1, sm: 1, md: 2/12, lg: 2/12}[cw]} 
                                    mb={{xs: "0.5em", sm: "0.5em", md: "0.5em"}[cw]}  style={{textAlign: "right"}}>
                                        <ButtonGroup fullWidth={fullWidthBtnGroup} variant="outlined" 
                                            color="primary" size="small" style={{height: "40px"}}>
                                            <Button onClick={e => append(colloDefault)}><AddCircleSharp /></Button>        
                                            <Button disabled={!spedizioniweb2?.isloggedin() ?? false}  onClick={e => setDrawerTipiColli({open: true, index})}><SpeedSharp /></Button>                        
                                            <Button disabled={fields.length < 2} onClick={e => remove(index)} color="secondary"><DeleteForeverSharp /></Button>
                                        </ButtonGroup>                            
                                </Grid>

                            </Grid>
                        {/* </fieldset>                                        */}
                        
                    </Box>
                    
                )
            })}

        </>
    )
}

export default Pacchi; 
export {colloDefault, _Pacchi, CampiNum}
